import {useFormContext} from "react-hook-form";
import {PhoneNumberInput} from "../../../../../../../shared/components/PhoneNumberInput";
import {CreateKycBasicFormStepFormValues} from "../../schema-validation";

export function KycPhoneNumberFormField() {
  const {control} = useFormContext<CreateKycBasicFormStepFormValues>();
  return <PhoneNumberInput control={control as never} />;
}
